module.exports = __webpack_public_path__ + "static/media/player-loader.a3befb30.gif";